import { get, post, put, del } from "../../utils/axiosInstance";

const BASE_URL = "/rest/shipments";

// ---------------------------------------------------------------------------
//  SHIPMENTS
// ---------------------------------------------------------------------------
export const fetchShipments = (page, shipmentId = null, itemName = null, shipmentDate = null, shipmentCustomer = null) => {
  let url = `${BASE_URL}/shipments/?page=${page}`;
  if (shipmentId) url += `&id=${shipmentId}`;
  if (itemName) url += `&item_name=${itemName}`;
  if (shipmentDate) url += `&creation_date=${shipmentDate}`;
  if (shipmentCustomer) url += `&destination=${shipmentCustomer}`;
  return get(url);
};

export const fetchShipment = (id) => {
  const url = `${BASE_URL}/shipments/${id}/`;
  return get(url);
};

export const createShipment = (data) => {
  const url = `${BASE_URL}/shipments/`;
  return post(url, data);
};

export const updateShipment = (id, data) => {
  const url = `${BASE_URL}/shipments/${id}/`;
  return put(url, data);
};

export const fetchDestinations = () => {
  const url = `${BASE_URL}/locations/`;
  return get(url);
};

export const finishShipment = (id) => {
  const url = `${BASE_URL}/shipments/${id}/finish/`;
  return post(url);
};

// ---------------------------------------------------------------------------
//  PACKAGES
// ---------------------------------------------------------------------------
export const fetchPackageTypes = () => {
  const url = `${BASE_URL}/package-types/`;
  return get(url);
};

export const createPackage = (data) => {
  const url = `${BASE_URL}/packages/`;
  return post(url, data);
};

export const deletePackage = (id) => {
  const url = `${BASE_URL}/packages/${id}/`;
  return del(url);
};

export const addItemToPackage = (packageId, inventoryId, format, times, forcePack = false) => {
  // Hack for backwards compatibility with old labels
  const oldLabelFormat = /http:\/\/inventory:8082\/Inventory2\/Action_Pages\/QrScanPage.php?[\W\w]*uniqueid=(\d+)[\W\w]*/;
  if (oldLabelFormat.test(inventoryId)) {
    inventoryId = oldLabelFormat.exec(inventoryId)[1];
  }
  const url = `/rest/inventory/inventory/${inventoryId}/add_to_package/`;
  const body = { packageId, times, format };
  if (forcePack) {
    body.force_pack = true;
  }
  return post(url, body);
};

export const deleteItemFromPackage = (packageId, inventoryId) => {
  // Hack for backwards compatibility with old labels
  const oldLabelFormat = /http:\/\/inventory:8082\/Inventory2\/Action_Pages\/QrScanPage.php?[\W\w]*uniqueid=(\d+)[\W\w]*/;
  if (oldLabelFormat.test(inventoryId)) {
    inventoryId = oldLabelFormat.exec(inventoryId)[1];
  }
  const url = `/rest/inventory/inventory/${inventoryId}/delete_from_package/`;
  return post(url, { packageId });
};

// ---------------------------------------------------------------------------
//  RETURNS
// ---------------------------------------------------------------------------
export const createReturn = (data) => {
  const url = `${BASE_URL}/returns/`;
  return post(url, data);
};

export const fetchReturn = (id) => {
  const url = `${BASE_URL}/returns/${id}/`;
  return get(url);
};

export const fetchReturns = (page, returnId = null, shipmentId = null, returnDate = null, customer = null) => {
  let url = `${BASE_URL}/returns/?page=${page}`;
  if (returnId) url += `&id=${returnId}`;
  if (shipmentId) url += `&shipment__id=${shipmentId}`;
  if (returnDate) url += `&created_at=${returnDate}`;
  if (customer) url += `&shipment__destination__id=${customer}`;
  return get(url);
};

export const fetchReturnCategories = () => {
  const url = `${BASE_URL}/return-categories/`;
  return get(url);
};

export const getShipmentBoxes = (sId) => {
  const url = `${BASE_URL}/shipments/${sId}/return_boxes`;
  return get(url);
};

export const addInventoriesFromReturn = (rId, data) => {
  const url = `${BASE_URL}/returns/${rId}/add_from_return/`;
  return post(url, data);
};

// ---------------------------------------------------------------------------
//  MARKET ORDERS
// ---------------------------------------------------------------------------
export const createShipmentForOrder = (orderId) => {
  const url = `${BASE_URL}/orders/${orderId}/create_shipment/`;
  return post(url);
};
